import React, { ChangeEvent, useState } from "react";
import Input from "components/form/input/Input";
import { isNumeric, isWholeNumber } from "helpers/Helpers";

interface IWebsiteBuilderNumberInputProps {
  label: string;
  initialValue: number;
  min: number;
  max: number;
  required: boolean;
  allowDecimals?: boolean;
  onChange: (updatedValue: number) => void;
}

export function WebsiteBuilderNumberInput(props: IWebsiteBuilderNumberInputProps) {
  const {
    label,
    initialValue,
    min,
    max,
    required,
    allowDecimals = false,
    onChange,
  } = props;
  
  const [inputValue, setInputValue] = useState<string>(initialValue == null ? "" : String(initialValue));

  function isInputValueValid(updatedInputValue: string) {
    if (updatedInputValue === "") {
      return !required;
    }

    const numUpdatedInputValue = Number(updatedInputValue);

    return (isWholeNumber(updatedInputValue) || (allowDecimals && isNumeric(updatedInputValue))) && numUpdatedInputValue >= min && numUpdatedInputValue <= max;
  }

  const inputValueValid = isInputValueValid(inputValue);

  function handleInputValueChange(e: ChangeEvent<HTMLInputElement>) {
    const updatedInputValue = e.target.value;
    
    setInputValue(updatedInputValue);

    if (isInputValueValid(updatedInputValue)) {
      onChange(updatedInputValue === "" ? null : Number(updatedInputValue));
    }
  }

  return (
    <Input
      label={label}
      value={inputValue}
      error={!inputValueValid}
      onChange={handleInputValueChange}
    />
  );
}